module.exports = {
	"title": {
		"cs-CZ": "Nahrávka z našeho posledního koncertu",
		"en-GB": "Recording of our last concert",
		"fr-FR": "Enregistrement de notre dernier concert",
		"de-DE": "Aufzeichnung unseres letzten Konzerts"
	},
	"text1": {
		"cs-CZ": "Vážení a milí příznivci souboru Musica pro Sancta Cecilia",
		"en-GB": "Dear friends of the ensemble Musica pro Sancta Cecilia",
		"fr-FR": "Chers amis de l'ensemble Musica pro Sancta Cecilia",
		"de-DE": "Liebe Freunde des Ensembles Musica pro Sancta Cecilia"
	},
	"text2": {
		"cs-CZ": "vzhledem k tomu, že v letošní době adventní a vánoční nemůžeme pořádat koncerty, rozhodli jsme se umístit na naše stránky nahrávku z našeho posledního koncertu, který se uskutečnil 12. ledna 2020 v Kobylisích kostele sv. Terezie od Dítěte Ježíše.",
		"en-GB": "Due to the fact that we cannot organize concerts this year for Advent and Christmas, we have decided to put on our website a recording of our last concert, which took place on January 12, 2020 in the church of Kobylisy, sv. Terezie od Dítěte Ježíše.",
		"fr-FR": "Étant donné que nous ne pouvons pas organiser de concerts cette année pour l'Avent et Noël, nous avons décidé de mettre sur notre site web un enregistrement de notre dernier concert, qui a eu lieu le 12 janvier 2020 à l'église de Kobylisy, sv. Terezie od Dítěte Ježíše.",
		"de-DE": "Da wir in diesem Jahr keine Advents- und Weihnachtskonzerte veranstalten können, haben wir uns entschlossen, auf unserer Website eine Aufnahme unseres letzten Konzerts zu veröffentlichen, das am 12. Januar 2020 in der Kirche von Kobylisy, sv. Terezie od Dítěte Ježíše."
	},
	"text3": {
		"cs-CZ": "Nahrávku naleznete v sekci ",
		"en-GB": "You will find the recording in the ",
		"fr-FR": "Vous trouverez l'enregistrement dans la section ",
		"de-DE": "Die Aufnahme finden Sie in der Rubrik "
	},
	"text4": {
		"cs-CZ": ".",
		"en-GB": " section.",
		"fr-FR": ".",
		"de-DE": "."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post03/Post03.json
// module id = 86
// module chunks = 0